import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {AuthEmailAddressTO} from "../../security/auth-email-address-to";
import {AuthenticationTO} from "../../classes/authentication-to";
import {ActivatedRoute, Router} from "@angular/router";
import {SessionTO} from "../../classes/session-to";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  mode = 'login';
  loginButtonText = 'Login';

  @Output()
  loggedIn = new EventEmitter();

  loggingIn = false;
  errorCode: string;
  errorMessage: string;

  authenticatedUser: string;

  loginForm = new FormGroup({
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  submitting = false;
  private returnUrl: string;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onLogon() {
    this.loginButtonText = "Logging in...";
    this.submitting = true;
    this.errorCode = undefined;
    this.errorMessage = undefined;

    const username = this.loginForm.value.emailAddress;
    const password = this.loginForm.value.password;

    this.authService.loginProxy(username, password).subscribe(response => {
      console.log('loginProxy.response: ');
      console.dir(response);
      const authenticationTO = response as AuthenticationTO;
      if (authenticationTO.success) {
        const payload: any = {};
        payload.data = 'event-logged-in';
        payload.username = authenticationTO.username;
        payload.firstName = authenticationTO.firstName;
        payload.roles = authenticationTO.roles;

        const sessionTO: SessionTO = new SessionTO();
        sessionTO.auth = true;
        sessionTO.username = authenticationTO.username;
        sessionTO.message = "logged in"

        this.authService.setSession(sessionTO);

        this.loggedIn.emit(payload);

        if (window.parent) {
          window.parent.window.postMessage(payload, window.location.origin);
        } else {
          window.postMessage(payload, window.location.origin);
        }
        console.log('sending login payload');
        console.dir(payload);

        this.loggingIn = false;

        this.updateLoginStatus();
        localStorage.setItem('authUser', username);

        if (this.returnUrl) {
          this.router.navigateByUrl(this.returnUrl);
        } else {
          this.router.navigateByUrl('/dashboard');
        }

      } else {
        this.loggingIn = false;
        this.submitting = false;
        this.loginButtonText = "Login";
        this.errorCode = "DSC2U-AUTH-1";
        this.errorMessage = "Invalid credentials.";
      }
    }, error => {
      console.log('loginProxy.error: ');
      console.dir(error);
      this.submitting = false;
      this.loginButtonText = "Login";
      this.loggingIn = false;
      this.updateLoginStatus();
    });

    // this.authService.processEmailAddress(this.loginForm.controls.emailAddress.value).subscribe(response => {
    //   const authEmailAddressTO = response as AuthEmailAddressTO;
    //   console.log('onProcessLoginEmailAddress.authEmailAddressTO:');
    //   console.dir(authEmailAddressTO);
    //
    //   this.submitting = false;
    //
    // });

  }

  updateLoginStatus() {
    this.authService.getLoginStatus().subscribe(data => {
      console.log('updateLoginStatus.sproutDataService.getTest.data: ');
      console.dir(data);
      if (data) {
        const output = data as any;
        this.authenticatedUser = output.email;
      } else {
        this.authenticatedUser = undefined;
      }
    });

  }

  onSignUp() {
    this.router.navigateByUrl('/sign-up');
  }

    onForgotPassword() {
      this.router.navigateByUrl('/forgot');
    }
}
